import { DataArray, IDataArray } from "./../../shared/index";

export class Project implements IDataArray {
  public Project_ID: number;
  public Project_Title: string;
  public Is_Deleted: boolean;
  public Created_By: number;
  public Created_Date: Date;
  public Modified_By: number;
  public Modified_Date: Date;
  public Is_Published: boolean;
  public Published_Date: Date;
  public Published_By: number;

  public GetById(): number {
    return this.Project_ID;
  }
}
